<body class="ltr main-body leftmenu">
    <div class="main-content side-content" [formGroup]="ExamSCEditForm">
        <div class="main-container container-fluid">
            <div class="inner-body">
                <div class="row row-sm">
                    <div class="col-lg-12">
                        <div class="card custom-card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class=" d-flex align-items-center pl-3">
                                            <img alt="Logo" src="../../assets/img/ExamMaster.png" class="mh-45px pb-2">
                                            <div class="ml-2">
                                                <h3 class="main-content-label mb-1"><b>
                                                        Exam Edit Control
                                                    </b></h3>
                                                <p class="text-muted card-sub-title mb-0">
                                                    Edit Exam By Supervisor
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr class="mt-1 mb-2">
                                <!-- <div class="card-body"> -->
                                <div class="row clearfix">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Session</mat-label>
                                                    <mat-select #selectSession class="colorblack"
                                                                formControlName="SessionId"
                                                                (selectionChange)="onSessionChange($event.value)"
                                                                required>
                                                        <mat-select-filter *ngIf="selectSession.focused"
                                                                           [placeholder]="'Filter'"
                                                                           [displayMember]="'SnName'"
                                                                           [array]="sessionList"
                                                                           (filteredReturn)="filteredSessionList = $event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredSessionList"
                                                                    [value]="item.SnNo">
                                                            {{ item.SnName }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamSCEditForm.controls['SessionId'].touched && ExamSCEditForm.controls['SessionId'].errors?.required">
                                                        Mandatory
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Exam Available</mat-label>
                                                    <mat-select formControlName="EcShId" #select3901 required
                                                        placeholder="Exam Available" class="colorblack">
                                                        <mat-select-filter *ngIf="select3901.focused"
                                                            [placeholder]="'Exam Available'" [displayMember]="'EmName'"
                                                            [array]="ExamAList"
                                                            (filteredReturn)="filteredExamAList =$event">
                                                        </mat-select-filter>
                                                        <mat-option (click)="loadExamRecords()"
                                                            *ngFor="let item of filteredExamAList" [value]="item.ShId"
                                                            (click)="reset(item.ShId,item.ShEmId)">
                                                            {{item.EmCode}} - {{item.EmName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamSCEditForm.controls['EcShId'].touched && ExamSCEditForm.controls['EcShId'].errors?.required">
                                                        Mandatory
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label> Input</mat-label>
                                                    <mat-select formControlName="FrontEcInCode" #select3904
                                                        placeholder=" Input" class="colorblack">
                                                        <mat-select-filter *ngIf="select3904.focused"
                                                            [placeholder]="' Input'" [displayMember]="'InDesc'"
                                                            [array]="ExamInputList"
                                                            (filteredReturn)="filteredExamInputList =$event">
                                                        </mat-select-filter>
                                                        <mat-option (click)="loadExamRecords()"
                                                            *ngFor="let item of filteredExamInputList"
                                                            [value]="item.InCode" (click)="InputFor(item.InCode)"
                                                           >
                                                            {{item.InDesc}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3 ">
                                        <button type="button" class="btn btn-primary btn-icon-text floatright mt-1"
                                            (click)="addNew()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/plus.gif"
                                                    style="margin-right: 3px;">
                                                New
                                            </span>
                                        </button>
                                        <button type="button" (click)="printAll()"
                                            class="btn btn-primary btn-icon-text floatright mt-1 mr-3">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/printer.gif"
                                                    style="margin-right: 7px;">
                                                Print
                                            </span>
                                        </button>
                                    </div>
                                </div>
                                <hr class="mt-1 mb-2">
                                <div *ngIf="showDiv" class="row clearfix">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label> Input</mat-label>
                                                    <mat-select [disabled]="updatereadonly" formControlName="EcInCode" #select3905 required
                                                        placeholder=" Input" class="colorblack">
                                                        <mat-select-filter *ngIf="select3905.focused"
                                                            [placeholder]="' Input'" [displayMember]="'InDesc'"
                                                            [array]="ExamInputList"
                                                            (filteredReturn)="filteredExamInputList =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredExamInputList"
                                                            [value]="item.InCode" (click)="InputFor(item.InCode)">
                                                            {{item.InDesc}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamSCEditForm.controls['EcInCode'].touched && ExamSCEditForm.controls['EcInCode'].errors?.required">
                                                        Mandatory
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        Description
                                                    </mat-label>
                                                    <input formControlName="EcDesc" maxlength="30"
                                                        onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                        type="text" placeholder="Description" matInput>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="showDiv" class="row clearfix">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Operator</mat-label>
                                                    <mat-select formControlName="EcOpId" #select3903 [disabled]="updatereadonly"
                                                        placeholder="Operator" class="colorblack">
                                                        <mat-select-filter *ngIf="select3903.focused"
                                                            [placeholder]="'Operator'" [displayMember]="'LoginFullName'"
                                                            [array]="userList"
                                                            (filteredReturn)="filtereduserList =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filtereduserList"
                                                            [value]="item.LoginId">
                                                            {{item.LoginFullName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamSCEditForm.controls['EcOpId'].touched && ExamSCEditForm.controls['EcOpId'].errors?.required">
                                                        Mandatory
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-1">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        List
                                                    </mat-label>
                                                    <input formControlName="EcListNo" [readonly]="updatereadonly"
                                                        onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                        type="text" placeholder="List" matInput>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="form-group">
                                            <div class="">
                                                <!--  [color]="color"
                                                            [checked]="checked" [disabled]="disabled" -->
                                                <!-- <mat-slide-toggle class="example-margin">
                                                            Status
                                                        </mat-slide-toggle> -->
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Status</mat-label>
                                                    <mat-select formControlName="EcStatus" #select3900
                                                        placeholder="statusList" class="colorblack">
                                                        <mat-select-filter *ngIf="select3900.focused"
                                                            [placeholder]="'statusList'" [displayMember]="'name'"
                                                            [array]="statusList"
                                                            (filteredReturn)="filteredstatusList =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredstatusList"
                                                            [value]="item.id">
                                                            {{item.name}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-sm-12 prpl">
                                            <button type="button" *ngIf="updateButton && ExDelete"
                                                class="btn btn-primary btn-icon-text floatright mt-1"
                                                (click)="DeletetheRecord()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/trash.gif"
                                                        style="margin-right: 5px;">
                                                    Delete
                                                </span>
                                            </button>

                                            <button *ngIf="EditListShow" type="button" [disabled]="submitButton && ExCreate"
                                                class="btn btn-primary btn-icon-text floatright mt-1 mr-3"
                                                (click)="print()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/printer.gif"
                                                        style="margin-right: 7px;">
                                                    Edit List
                                                </span>
                                            </button>

                                            <button type="button" *ngIf="updateButton && ExUpdate"
                                                class="btn btn-primary btn-icon-text floatright mt-1 mr-3"
                                                (click)="update()" [disabled]="updateDisable">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/edit1.gif"
                                                        style="margin-right: 7px;">
                                                    Update
                                                </span>
                                            </button>
                                            <button type="button" *ngIf="submitButton && ExCreate"
                                                class="btn btn-primary btn-icon-text floatright mt-1 mr-3"
                                                (click)="submit()" [disabled]="SaveDisable">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/save.gif"
                                                        style="margin-right: 5px;">
                                                    Save
                                                </span>
                                            </button>



                                        </div>

                                        <!-- <div class="col-sm-8 prpl"></div>
                                            <div class="col-sm-2 pri-0" *ngIf="submitButton && ExCreate">
                                            </div>
                                            <div class="col-sm-2 pri-0" *ngIf="updateButton && ExUpdate">
                                            </div>
                                            <div class="col-sm-2 pri-0" *ngIf="updateButton && ExDelete">
                                            </div> -->
                                    </div>
                                </div>

                                <div *ngIf="Table" class="row clearfix">
                                    <div class="col-sm-12">
                                        <table id="datatable" class="table  table-bordered text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th class="f600">
                                                        EC
                                                    </th>
                                                    <th class="f600">
                                                        Input
                                                    </th>
                                                    <th class="f600">
                                                        List
                                                    </th>
                                                    <th class="f600">
                                                        Description
                                                    </th>
                                                    <th class="f600 text-center">
                                                        Operator
                                                    </th>
                                                    <th class="f600 text-center">
                                                        Opened
                                                    </th>
                                                    <th class="f600 text-center">
                                                        Status
                                                    </th>
                                                    <th *ngIf="FeesNotPaid">
                                                        View
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let exam of examRecords;" [class.selected-row]="exam === selectedRow" (click)="selected(exam)" (click)="prepopulate(exam)">
                                                    <td>{{exam.EcId}} </td>
                                                    <td>{{exam.InDesc}} </td>
                                                    <td> {{exam.EcListNo}} </td>
                                                    <td>{{exam.EcDesc}} </td>
                                                    <td class="text-center">{{exam.L1}} </td>
                                                    <td class="text-center"> {{exam.L2}} </td>
                                                    <td *ngIf="exam.EcStatus == 'U'">
                                                        Updated
                                                    </td>
                                                    <td *ngIf="exam.EcStatus == 'O'">
                                                        Open
                                                    </td>
                                                    <td *ngIf="FeesNotPaid  && exam.EcInCode == 19 && exam.EcStatus == 'O'" (click)="openGrid()">
                                                        <i class="fa fa-eye eye"></i>
                                                    </td>
                                                    <!-- <td class="text-center"> {{exam.EcStatus}} </td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div *ngIf="updateDisableMsg">
                                    <p><b class="red">Note : {{UpdateError}}</b></p>
                                </div>
                                <div *ngIf="SaveDisable">
                                    <p><b class="red">Note : {{SaveError}}</b></p>
                                </div>
                                <!-- </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>